import { RenderTiles } from '../../components/common';
import ChildHeader from '../../components/ui/ChildHeader';
import { subTiles2 } from './SubTiles';

const PressShopSection = () => {
  // for ideal components
  return (
    <>
      <ChildHeader text="Press Shop Section" />
      <RenderTiles tilesObj={subTiles2} height="100vh" justify="start" />
    </>
  );
};

export default PressShopSection;
